
import _ from 'lodash'
import { baseURL, formatFetchError, fetchHeaders } from '../util'
import { Metadata } from 'next'

export async function usedMakeBodyType(q: object): Promise<Metadata> {
  try {
    const res = await fetch(`${baseURL}/meta/used-make-body-type?${new URLSearchParams({ ...q })}`, {
      method: 'GET',
      headers: await fetchHeaders(),
      next: { revalidate: 10 },
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}